// makeWordBreakSafe replaces breaking dash with non-breaking dash (&#8209;)
// This is used to avoid word breaks with dashes in iOS.
export const makeWordBreakSafe = (text: string) => {
  return text.replace(/-/g, "‑");
};
